import { motion } from "framer-motion";

const outcomes = [
  {
    result: "12 hrs/week",
    detail: "saved on scheduling & follow-ups",
    industry: "Medical practice, Montclair NJ",
  },
  {
    result: "3× faster",
    detail: "lead response time with AI intake",
    industry: "Law firm, Essex County NJ",
  },
  {
    result: "40% less",
    detail: "admin overhead in the first month",
    industry: "Fitness studio, Bloomfield NJ",
  },
];

const SocialProof = () => (
  <section
    aria-label="Client outcomes"
    className="py-12 md:py-16 bg-canvas border-y border-border"
  >
    <div className="container mx-auto px-4 sm:px-6">
      <motion.p
        initial={{ opacity: 0, y: 8 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4 }}
        className="text-center text-sm font-medium text-muted-foreground uppercase tracking-widest mb-8"
      >
        Real results from NJ small businesses
      </motion.p>
      <div className="grid gap-6 sm:grid-cols-3">
        {outcomes.map((o, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className="rounded-xl bg-background border border-border p-6 text-center shadow-sm"
          >
            <p className="text-3xl font-bold font-display text-primary mb-1">{o.result}</p>
            <p className="text-sm text-foreground font-medium mb-2">{o.detail}</p>
            <p className="text-xs text-muted-foreground">{o.industry}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default SocialProof;
